import {newPalette, NewPaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/colorStyles';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';
import {UserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

export const getNewPaletteColorScheme = (color = NewPaletteColorsEnum.BLUE) =>
  Object.values(newPalette[color]);

export const getOldPaletteColorScheme = (theme: UserTheme, color = PaletteColorsEnum.BLUE) => {
  const scheme = Object.values(theme.palette[color]);
  if (color === PaletteColorsEnum.ORANGE || color === PaletteColorsEnum.YELLOW) {
    return scheme.slice(1); // Removing 'highlight' color from the scheme.
  }
  return scheme;
};

export const getHeatmapColors = (
  theme: UserTheme,
  color = NewPaletteColorsEnum.ORANGE,
  isLoading?: boolean,
) => ({
  binColors: [
    // TODO these can't be the final colors, too much confusion to mix new and old palette.
    theme.palette[color].shade10,
    theme.palette[color].shade20,
    theme.palette[color].shade30,
    newPalette[color].regular,
    isLoading ? theme.palette[color].shade50 : newPalette[color].lowlight,
  ],
  textColors: [
    newPalette[color].lowlight,
    newPalette[color].lowlight,
    newPalette[color].lowlight,
    theme.greys.white,
    theme.greys.white,
  ],
});
